type Longest<T1 extends any[], T2 extends any[]> = any[] extends T1
  ? T1
  : any[] extends T2
  ? T2
  : Exclude<keyof T1, keyof T2> extends never
  ? T2
  : T1;

/**
 * A rigorous type alias for a class.
 */
export type Class<
  CtorArgs extends any[] = any[],
  InstanceType = {},
  StaticType = {},
  IsAbstract = false
> = (abstract new (...args: any[]) => InstanceType) & StaticType;

function extraInherit<A1 extends any[], I1, S1, A2 extends any[], I2, S2>(
  c1: Class<A1, I1, S1>,
  c2: Class<A2, I2, S2>
): Class<Longest<A1, A2>, I1 & I2, S1 & S2> {
    
  Object.getOwnPropertyNames(c2.prototype).forEach((name) => {
    if (name !== "constructor") {
      c1.prototype[name] = c2.prototype[name];
    }
  });
  const mergedClass: any = c1;
  return mergedClass;
}

export default extraInherit;
